import { render, staticRenderFns } from "./admin-data.vue?vue&type=template&id=d3afd4b4&scoped=true&"
import script from "./admin-data.vue?vue&type=script&lang=js&"
export * from "./admin-data.vue?vue&type=script&lang=js&"
import style0 from "./admin-data.vue?vue&type=style&index=0&id=d3afd4b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3afd4b4",
  null
  
)

export default component.exports